import React from "react";
import {Form,Card,Row,Col} from 'antd';
import NHFetch from "../../../utils/NHFetch";
import NHFormItem from "../../common/NHFormItem";
const baseUrlPath = "/xxfb"; //信息发布管理模块路径

/**
 * 信息发布查看表单
 */
class ViewForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            nr:'',
        }
    }

    componentWillMount(){
        const {initFormData} =  this.props;
        let pkid = initFormData['PKID'];
        if(pkid!=undefined && pkid !=''){
            this.getNr(pkid);
        }
    }

    getNr=(pkid)=>{
        let url = baseUrlPath + '/getNr/'+pkid;
        NHFetch(url,'GET')
            .then(res => {
                if (res) {
                    if (res.data) {
                        this.setState({nr:res.data});
                    }
                }
            })
    }

    render() {
        const {initFormData,form} = this.props;
        return (
           <div>
               <NHFormItem label={"分类标志"} form={form}>
                   <span>{initFormData.FLBT}</span>
               </NHFormItem>
               <NHFormItem label={"信息发布标题"} form={form}>
                   <span>{initFormData.TZBT}</span>
               </NHFormItem>
               <NHFormItem label={"信息发布内容"} form={form}>
                   <div dangerouslySetInnerHTML={{__html: this.state.nr}} />
               </NHFormItem>
               <style jsx global>{`
                    .ant-form-item-label{
                        font-weight: bold;
                    }
               `
               }</style>
            </div>
        );
    }
}
const viewForm = Form.create()(ViewForm);

export default viewForm;


// WEBPACK FOOTER //
// ./components/fwwgl/xxfb/ViewForm.js